import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import "./LoginMenu.css";

/**
 * Login control offering the two places a visitor can land: the LawFusion app
 * and the attorney directory. Both go through the same authentication — the
 * choice only decides where they end up afterwards, which /login reads back
 * from the `area` query parameter.
 */
export default function LoginMenu({ className = "", onNavigate }) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;

    const onDocClick = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };

    document.addEventListener("mousedown", onDocClick);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDocClick);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  const go = (area) => {
    setOpen(false);
    if (onNavigate) onNavigate();
    navigate(area === "directory" ? "/login?area=directory" : "/login");
  };

  return (
    <div className="login-menu" ref={wrapRef}>
      <button
        type="button"
        className={`login-menu-trigger ${className}`}
        onClick={() => setOpen((o) => !o)}
        aria-haspopup="menu"
        aria-expanded={open}
      >
        Login
        <ChevronDown
          size={14}
          className={`login-menu-caret${open ? " open" : ""}`}
        />
      </button>

      {open && (
        <div className="login-menu-panel" role="menu">
          <button type="button" role="menuitem" onClick={() => go("lawfusion")}>
            Log in to LawFusion
          </button>
          <button type="button" role="menuitem" onClick={() => go("directory")}>
            Log in to Directory
          </button>
        </div>
      )}
    </div>
  );
}
